/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SizeModal from "./SizeForm";
import Constants from "../../../../common/Constants";
import MasterList from "../../../common/MasterList";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import {
  fetchMasterList,
  addMasterRecord,
  deleteMasterRecord,
  fetchMasterListById,
  searchMasterList,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { toastFunc } from "../../../../components/common/util";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { ErrorModal } from "../../../common/errorModal";
import Process from "./Process";
import { AlertModal } from "../../../common/AlertModal";
import UploadExcel from "../../../../components/common/UploadExcel";
import { formatDateTime } from "../../../../common/Validations";

const Size = () => {
  const [open, setOpen] = useState(false);
  const [uploadModelOpen, setUploadModelOpen] = useState(false);
  const [openProcess, setOpenProcess] = useState(false);
  const [sizeCode, setSizeCode] = useState([]);
  const [sizeName, setSizeName] = useState([]);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [selectedItem, setSelectedItem] = useState([]);
  const [editDept, setEditDept] = useState();
  const [confirmModel, setConfirmModel] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [searchValue, setSearchValue] = useState();

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleClose = () => {
    setOpen(false);
  };
  const handleUploadClose = () => {
    setUploadModelOpen(false);
  };
  const handleProcessClose = () => {
    setOpenProcess(false);
  };

  const resetAlert = () => {
    setIsAlert(false);
  };
  useEffect(() => {
    dispatch(fetchMasterList(Constants.MASTER.SIZE)); // userSlice store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = (data, edit) => {
    const param = { ...data };
    if (!edit) {
      param.method = Constants.MASTER.SIZE.ADD;
    } else {
      param.method = Constants.MASTER.SIZE.UPDATE;
    }
    param.edit = edit;
    dispatch(addMasterRecord(param)).then((res) => {
      console.log(">> item >>", res);
      if (res?.payload?.status === 200) {
        if (!edit) {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_master_list.msg_size.success_message"),
            2000
          );
        } else {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_master_list.msg_size.update_success_message"),
            2000
          );
        }
        dispatch(fetchMasterList(Constants.MASTER.SIZE)); // userSlice store
        setOpen(false);
      } else {
        //toastFunc(Constants.MASTER.TOAST.error,t("msg_master_list.msg_department.invalid_input"),4000)
        setError(res.payload.message);
        setIsError(true);
      }
    });
  };

  useEffect(() => {
    dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT)); // userSlice store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let deptmasterList = useSelector((state) => state?.masterList?.page);
  const deptList = deptmasterList[Constants.MASTER.DEPARTMENT.name]?.data;

  const deptCodeList = deptList?.map((entry) => entry.deptCode);

  const deptNameList = deptList?.map((entry) => entry.deptName);

  const handleUploadData = (data) => {
    try {
      let sizeRecords = [];
      let ProcessRecords = [];
      let tempSize = {};
      let tempProcess = {};
      let processObj = {};
      if (data) {
        // eslint-disable-next-line array-callback-return
        data.map((item, index) => {
          if (!item?.SizeCode || !item?.SizeName) {
            setError(t("msg_master_list.msg_size.info_missing"));
            setIsError(true);
            throw new Error(t("msg_master_list.msg_size.info_missing"));
          }

          if (!deptCodeList.includes(item.DepartmentCode)) {
            const message =
              t("msg_master_list.msg_size.invalid_deptcode") +
              item.DepartmentCode;
            setError(message);
            setIsError(true);
            throw new Error(message);
          }

          if (sizeCodeList.includes(item.SizeCode)) {
            const message =
              t("msg_master_list.msg_size.duplicate_size_code") +
              item.SizeCode;
            setError(message);
            setIsError(true);
            throw new Error(message);
          }

          if (!deptNameList.includes(item.DepartmentName)) {
            const message =
              t("msg_master_list.msg_size.invalid_deptName") +
              item.DepartmentName;
            setError(message);
            setIsError(true);
            throw new Error(message);
          }

          if (!tempSize?.sizeCode && !tempProcess?.SizeCode) {
            tempSize.sizeCode = item.SizeCode;
            tempSize.sizeName = item.SizeName;
            tempSize.sizeStatus = "Active";
            tempSize.reportTitle = item.ReportTitle;
            tempSize.qcSizeCode = item.QCSizeCode;
            tempSize.boreDepth = item.BoreDepth;
            tempSize.weightInGrams = item.WeightInGrams;
            tempProcess.process = [];
            tempProcess.sizeCode = item.SizeCode;
            tempProcess.sizeName = item.SizeName;
            tempProcess.reportTitle = item.ReportTitle;
            tempProcess.qcSizeCode = item.QCSizeCode;
            tempProcess.boreDepth = item.BoreDepth;
            processObj.deptCode = item.DepartmentCode;
            processObj.deptName = item.DepartmentName;
            processObj.cycleTime = item.CycleTime;
            processObj.processOrder = parseInt(item.Order);
            tempProcess.process.push(processObj);
          } else if (tempSize?.sizeCode === item?.SizeCode) {
            processObj = {};
            processObj.deptCode = item.DepartmentCode;
            processObj.deptName = item.DepartmentName;
            processObj.processOrder = parseInt(item.Order);
            processObj.cycleTime = item.CycleTime;
            tempProcess.process.push(processObj);
          } else if (tempSize?.sizeCode !== item?.SizeCode) {
            sizeRecords.push(tempSize);
            tempSize = {};
            tempSize.sizeCode = item.SizeCode;
            tempSize.sizeName = item.SizeName;
            tempSize.reportTitle = item.ReportTitle;
            tempSize.qcSizeCode = item.QCSizeCode;
            tempSize.boreDepth = item.BoreDepth;
            tempSize.weightInGrams = item.WeightInGrams;
            tempSize.sizeStatus = "Active";

            ProcessRecords.push(tempProcess);

            tempProcess = {};
            tempProcess.process = [];
            processObj = {};
            tempProcess.sizeCode = item.SizeCode;
            tempProcess.sizeName = item.SizeName;
            tempProcess.reportTitle = item.ReportTitle;
            tempProcess.qcSizeCode = item.QCSizeCode;
            tempProcess.boreDepth = item.BoreDepth;
            processObj.deptCode = item.DepartmentCode;
            processObj.deptName = item.DepartmentName;
            processObj.cycleTime = item.CycleTime;
            processObj.processOrder = parseInt(item.Order);
            tempProcess.process.push(processObj);
          }
          if (index === data.length - 1) {
            sizeRecords.push(tempSize);
            ProcessRecords.push(tempProcess);
          }
        });
      }
      let sizeParam = {};
      let processParam = {};
      sizeParam.sizeRecords = sizeRecords;

      sizeParam.method = Constants.MASTER.SIZE.UPLOAD;

      dispatch(addMasterRecord(sizeParam)).then((res) => {
        console.log(">> item >>", res);
        if (res?.payload?.status === 200) {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_master_list.msg_size.success_message"),
            2000
          );
          dispatch(fetchMasterList(Constants.MASTER.SIZE)); // userSlice store
          processParam.ProcessRecords = ProcessRecords;
          processParam.method = Constants.MASTER.PROCESS.UPLOAD;
          dispatch(addMasterRecord(processParam)).then((res) => {
            console.log(">> item >>", res);
            if (res?.payload?.status === 200) {
              toastFunc(
                Constants.MASTER.TOAST.success,
                t("msg_master_list.msg_process.success_message"),
                2000
              );
              setUploadModelOpen(false);
            } else {
              setError(res.payload.message);
              setIsError(true);
              setUploadModelOpen(false);
            }
          });
        } else {
          setError(res.payload.message);
          setIsError(true);
          setUploadModelOpen(false);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = () => {
    let param = {};
    param.sizeList = selectedItem;
    param.method = Constants.MASTER.SIZE.DELETE;

    dispatch(deleteMasterRecord(param)).then((res) => {
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_size.delete_success_message"),
          2000
        );
        dispatch(fetchMasterList(Constants.MASTER.SIZE));
        setSelectedItem([]);
        setConfirmModel(false);
      } else {
        setIsError(true);
        toastFunc(
          Constants.MASTER.TOAST.error,
          t("msg_master_list.msg_size.invalid_input"),
          4000
        );
      }
    });
  };

  const handleOpen = (data) => {
    if (data) {
      setEditDept(data);
    }
    setOpen(true);
  };

  const handleUploadOpen = (data) => {
    setUploadModelOpen(true);
  };

  const handleRowSelected = ({ selectedRows }) => {
    const selectDept = selectedRows.map((item) => item.sizeCode);
    setSelectedItem(selectDept);
  };
  const handleProcess = (row) => {
    let param = {};
    param.url = "getProcessMasterListDataById";
    param.page = Constants.MASTER.PROCESS.name;
    param.id = row.sizeCode;

    if (row.sizeCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        setOpenProcess(true);
        setSizeCode(row.sizeCode);
        setSizeName(row.sizeName);
      });
    }
  };

  const confirmBeforeDelete = (data, singleDelete = false) => {
    if (singleDelete) {
      setSelectedItem([data.sizeCode]);
      setConfirmModel(true);
    } else {
      if (selectedItem.length === 0) {
        setIsAlert(true);
        return;
      } else {
        setConfirmModel(true);
      }
    }
  };

  const resetError = () => {
    setIsError(false);
    setError("");
  };

  let masterList = useSelector((state) => state?.masterList?.page); // User Details from Store
  let rowsData = masterList[Constants.MASTER.SIZE.name]?.data;

  const sizeCodeList = rowsData?.map((entry) => entry.sizeCode);

  const handleSearch = () => {
    const param = {
      ...Constants.MASTER.SIZE,
      value: searchValue,
    };
    if (searchValue) {
      dispatch(searchMasterList(param)).then((res) => {
        if (res?.payload?.status === 200) {
          rowsData = res?.payload?.data;
        }
      });
    }
  };

  const onSearchChange = (e) => {
    if (e.target.value) {
      setSearchValue(e.target.value);
    } else {
      dispatch(fetchMasterList(Constants.MASTER.SIZE));
      setSearchValue(e.target.value);
    }
  };

  const columnsData = [
    {
      name: t("msg_common.actions"),
      cell: (row) => (
        <>
          <span>
            <i
              className="bi bi-pencil-square iconTable"
              onClick={() => handleOpen(row)}
            ></i>
          </span>
          <span>
            <i
              className="bi bi-trash3 iconTable"
              onClick={() => confirmBeforeDelete(row, true)}
            ></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: t("msg_master_list.msg_size.code"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.sizeCode} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_size.size_name"),
      selector: (row) => row.sizeName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.sizeName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_size.view_process"),
      cell: (row) => (
        <Button variant="outline-primary" onClick={() => handleProcess(row)}>
          {row.lastName}
          {"Process"}
        </Button>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_master_list.msg_size.report_title"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.reportTitle} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_size.qc_code"),
      selector: (row) => row.qcSizeCode,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.qcSizeCode} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_size.bore_depth"),
      selector: (row) => row.boreDepth,
      sortable: true,
      width: "140px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.boreDepth} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_size.weight_in_grams"),
      selector: (row) => row.weightInGrams,
      sortable: true,
      width: "170px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.weightInGrams} </p>
        </div>
      ),
    },
    {
      name: t("msg_common.status"),
      cell: (row) => (
        <>
          {row.sizeStatus === Constants.MASTER.STATUS.Active ? (
            <span className="bg-table-status bg-table-success-status">
              {t("msg_common.active")}
            </span>
          ) : row.sizeStatus === Constants.MASTER.STATUS.Inactive ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.inactive")}
            </span>
          ) : (
            row.sizeStatus
          )}
        </>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_common.created_date"),
      selector: (row) => row.createdDate,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {formatDateTime(row?.createdDate)}{" "}
          </p>
        </div>
      ),
      center: true,
      width: "250px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">{t("msg_master_list.msg_size.name")}</h2>
            <p className="subText">{t("msg_master_list.msg_size.details")}</p>
          </div>
        </Col>
        <Col xs={4} md={4} className="rightSide">
          <Form>
            <Form.Group>
              <InputGroup>
                <Form.Control
                  type="search"
                  placeholder={t("msg_common.search_placeholder")}
                  onChange={(e) => onSearchChange(e)}
                />
                <InputGroup.Text>
                  <i className="bi bi-search" onClick={handleSearch}></i>
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>
          </Form>
        </Col>
        <hr />
      </Row>
      <MasterList
        columnsData={columnsData}
        rowsData={rowsData}
        paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
        pagination
        selectableRows
        handleClose
        uploadButton
        uploadData={handleUploadOpen}
        handleOpen={handleOpen}
        handleDelete={confirmBeforeDelete}
        handleRowSelected={handleRowSelected}
      />
      {open && (
        <SizeModal
          data={editDept}
          show={open}
          onHide={handleClose}
          onSave={handleSave}
        ></SizeModal>
      )}
      {uploadModelOpen && (
        <UploadExcel
          data={editDept}
          show={uploadModelOpen}
          onHide={handleUploadClose}
          handleFileUploadData={handleUploadData}
        ></UploadExcel>
      )}
      {confirmModel && (
        <ConfirmationModal
          show={confirmModel}
          heading={t("msg_master_list.msg_size.delete_confirm_heading")}
          bodyMessage={t("msg_master_list.msg_size.delete_confirm_body")}
          onDelete={() => handleDelete()}
          onHide={() => setConfirmModel(false)}
          type={"delete"}
        ></ConfirmationModal>
      )}
      {isError && (
        <ErrorModal
          show={isError}
          heading={t("msg_master_list.msg_size.size_error_heading")}
          bodyMessage={error}
          onHide={() => {
            resetError();
          }}
        ></ErrorModal>
      )}

      {openProcess && (
        <Process
          // rowsData={sizeData}
          show={openProcess}
          onHide={handleProcessClose}
          sizeCode={sizeCode}
          sizeName={sizeName}
        ></Process>
      )}
      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={t("msg_common.selectRecord")}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
    </main>
  );
};

export default Size;
